export default function Theme() {
  let output = { 
    primary: "#F15A24", 
    sideMenu: "#FFF7F1",
    background: "#FFF7F1",
    navBorder: "rgba(241, 90, 36, 0.38)",
    textPrimary: "#201F1F",
    textWhite: "#FFFFFF",
    attentionLight: "#FFE3DB",
    attentionCritical: "#C92C2C"
  };
  return output;
}
